export default __webpack_public_path__ + "static/media/japantrad3.2a867411.png";